module.exports = __webpack_public_path__ + "img/trial2-1.24754a94.png";